//-------------
// is counters
//-------------
export default function isCounters(props, marker) {
  // console.log("=============================")
  // console.log("isCounters")
  // console.log("cnt = " + props.row["counters"])

  // if (marker) {
  //   console.log("marker = " + marker.name)
  // }
  //----------------
  // if no counters
  //----------------
  if (props.row["counters"] == 0) {
    // console.log("iscounters1")
    return false;
    //---------------------------------------------------------
    // else must have counters - if new slot NOT marker - fail
    //---------------------------------------------------------
  } else if (!marker) {
    // console.log("iscounters2")
    return true;
    //-----------------------------------
    // else if new marker = counter - ok
    //-----------------------------------
  } else if (marker.name == "counter") {
    // console.log("iscounters3")
    return false;
    //----------------
    // default - fail
    //----------------
  } else {    
    // console.log("iscounters4")
    return true;
  }
}
